var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PositionDialogs,{attrs:{"value":_setup.isOpen,"center":"","title":"Clone Position","message":_setup.displayDescription,"icon":"org_icon_position","buttonType":"magenta","actionLabel":"Clone"},on:{"input":_setup.onClose,"onAction":_setup.onClone,"onClose":_setup.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }